import { Button } from "@components/ui/button";
import { Checkbox } from "@mui/material";
import { ArrowRight, ChevronLeft, X } from "lucide-react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { saveFiltersState, updateContactProfile } from "@redux/slices/filter";
import { useEffect, useState } from "react";
import { ContactProfileFilter } from "@/types/filters";

interface Props {
  handleClose: () => void;
}

const ContactProfile: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialProfile = {
    phoneNumber: {
      mobileNumber: false,
      directDialNumber: false,
      companyPhoneNumber: false,
    },
    emailAddress: {
      emailAvailable: false,
      emailSourceLink: false,
      emailValid: false,
    },
    contactSources: {
      linkedinProfile: false,
      xingProfile: false,
      businessRegister: false,
      companyWebsite: false,
      otherWebSources: false,
    },
  };
  const contactProfile =
    useSelector(
      (state: RootState) => state.filter?.contactFilters?.contactProfile
    ) || initialProfile;

    const data=useSelector((state: RootState)=>state.filter);

  const [profile, setProfile] = useState(initialProfile);

  useEffect(() => {
    console.log("Profile state updated fhgvjbk:", profile);
  }, [initialProfile]);

  const handleCheckboxChange = (category: keyof ContactProfileFilter, field: string) => {
    console.log(category, field);
  
    setProfile((prevProfile) => {
      const categoryProfile = prevProfile[category];
      if (categoryProfile === undefined) return prevProfile;
  
      const updatedCategory = {
        ...categoryProfile,
        [field as keyof typeof categoryProfile]: !categoryProfile[field as keyof typeof categoryProfile],
      };
  
      console.log(updatedCategory);
  
      dispatch(
        updateContactProfile({
          [category]: updatedCategory,
        })
      );
  
      return {
        ...prevProfile,
        [category]: updatedCategory,
      };
    });
  };
  

  return (
    <div className="flex flex-col justify-between h-full absolute top-0 w-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Contact Profile Completeness
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <div className="flex gap-4">
          <div className="w-1/2">
            <div className="bg-white rounded-lg px-6 py-4">
              <h4 className="text-lg font-bold flex items-center mb-4">
                Phone Number
              </h4>
              <div className="text-sm font-medium cursor-pointer text-[#71717A] pb-2">
                <h6 className="ms-1">Any phone number must be available</h6>
              </div>
              <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
                <h6 className="ms-1">Mobile Number</h6>
                <Checkbox
                  checked={contactProfile?.phoneNumber?.mobileNumber}
                  onChange={() =>
                    handleCheckboxChange("phoneNumber", "mobileNumber")
                  }
                  sx={{
                    color: '#1CB5AF', // Unchecked color
                    '&.Mui-checked': {
                      color: '#1CB5AF', // Checked color
                    },
                    padding:0
                  }}
                />
              </div>
              <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
                <h6 className="ms-1">Direct Dial Number</h6>
                <Checkbox
                  checked={contactProfile?.phoneNumber?.directDialNumber}
                  onChange={() =>
                    handleCheckboxChange("phoneNumber", "directDialNumber")
                  }
                  sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
                />
              </div>
              <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
                <h6 className="ms-1">Company Phone Number</h6>
                <Checkbox
                  checked={contactProfile?.phoneNumber?.companyPhoneNumber}
                  onChange={() =>
                    handleCheckboxChange("phoneNumber", "companyPhoneNumber")
                  }
                  sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
                />
              </div>
            </div>
            <div className="bg-white rounded-lg px-6 py-4 mt-4">
              <h4 className="text-lg font-bold flex items-center mb-4">
                Email Address
              </h4>
              <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
                <h6 className="ms-1 capitalize">email address available</h6>
                <Checkbox
                  checked={contactProfile?.emailAddress?.emailAvailable}
                  onChange={() =>
                    handleCheckboxChange("emailAddress", "emailAvailable")
                  }
                  sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
                />
              </div>
              <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
                <h6 className="ms-1 capitalize">
                  email address must have a public source link
                </h6>
                <Checkbox
                  checked={contactProfile?.emailAddress?.emailSourceLink}
                  onChange={() =>
                    handleCheckboxChange("emailAddress", "emailSourceLink")
                  }
                  sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
                />
              </div>
              <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
                <h6 className="ms-1 capitalize">email address must be valid</h6>
                <Checkbox
                  checked={contactProfile?.emailAddress?.emailValid}
                  onChange={() =>
                    handleCheckboxChange("emailAddress", "emailValid")
                  }
                  sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
                />
              </div>
            </div>
          </div>
          <div className="bg-white w-1/2 rounded-lg px-6 py-4 h-fit">
            <h4 className="text-lg font-bold mb-4">Contact Sources</h4>
            <div className="flex items-end text-sm justify-between font-medium cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
              <h6 className="ms-1">LinkeddsdIn Profile</h6>
              <Checkbox
                checked={contactProfile?.contactSources?.linkedinProfile}
                onChange={() =>
                  handleCheckboxChange("contactSources", "linkedinProfile")
                }
                sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
              />
            </div>
            <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
              <h6 className="ms-1">XING Profile</h6>
              <Checkbox
                checked={contactProfile?.contactSources?.xingProfile}
                onChange={() =>
                  handleCheckboxChange("contactSources", "xingProfile")
                }
                sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
              />
            </div>
            <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
              <h6 className="ms-1">Business Register</h6>
              <Checkbox
                checked={contactProfile?.contactSources?.businessRegister}
                onChange={() =>
                  handleCheckboxChange("contactSources", "businessRegister")
                }
                sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
              />
            </div>
            <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-2">
              <h6 className="ms-1">Company Website</h6>
              <Checkbox
                checked={contactProfile?.contactSources?.companyWebsite}
                onChange={() =>
                  handleCheckboxChange("contactSources", "companyWebsite")
                }
                sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
              />
            </div>
            <div className="flex items-end text-sm justify-between font-medium pt-3 cursor-pointer text-[#71717A] ">
              <h6 className="ms-1">Other Web Sources</h6>
              <Checkbox
                checked={contactProfile?.contactSources?.otherWebSources}
                onChange={() =>
                  handleCheckboxChange("contactSources", "otherWebSources")
                }
                sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end absolute bottom-[5px] right-[20px] ">
        <Button onClick={() => navigate(-1)} className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default ContactProfile;
